// Modules
import React from 'react';
import {connect} from 'react-redux';
import store from '../store'
import {leaveGameSocket} from '../actions/gameManagement';
import {
    addToRosterLocal,
    updateTeeScoreLocal,
    leaveGameLocal} from '../actions/matchManagement';
import {saveMatchResultsAsync} from '../actions/history';
// Comps & Styling
import GameScorecard from './gameScorecard';
import GameOutliner from './gameOutliner';
let d = new Date();
const gameDate = [
    d.getFullYear(),
    d.getMonth()+1,
    d.getDate()
];

export function Game(props){

    //region Socket
    props.socket.on('update-roster-local', function(roster){
        store.dispatch(addToRosterLocal(roster))
    });
    props.socket.on('score-update-clients', function(payload){
        store.dispatch(updateTeeScoreLocal(payload.gamertag, payload.score));
    });
    //endregion

    function leaveMatch(e){
        let gameroomPayload={
            socket: props.socket,
            gameroom: store.getState().match.gameroom
        };
        let jsonPayload={
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json"
            },
            method: 'POST',
            body: JSON.stringify({
                uuid: store.getState().user.uuid,
                title: store.getState().match.gameroom,
                location: store.getState().match.location,
                date: gameDate,
                roster: store.getState().match.roster
            })
        };

        store.dispatch(saveMatchResultsAsync(props.socket, jsonPayload));
        store.dispatch(leaveGameSocket(gameroomPayload));
        store.dispatch(leaveGameLocal());
    }

    return(
      <div id="container-game" className="menuWrapper">
          <div>
              <div style={{marginBottom: '1rem', verticalAlign: 'middle'}}>
                  <h5 style={{
                      marginTop: ".5rem",
                      marginBottom: "2rem",
                      paddingTop: ".5rem",
                      paddingBottom: ".5rem",
                      paddingLeft: "2rem",
                      paddingRight: "2rem",
                      display: "inline",
                      textDecoration: "underline"
                  }}>
                      Match {props.gameroom} at {props.location} on {gameDate[0]+'/'+gameDate[1]+'/'+gameDate[2]}.
                  </h5>
              </div>
              <GameScorecard id="container-gameScorecard"/>
              <GameOutliner id="container-gameOutliner" socket={props.socket}/>
          </div>
          <input id="btn-save-and-exit" type="button" value="Save History & Leave Match" onClick={e=>{leaveMatch(e)}} className="btnStretch btnColoring" style={{
              marginLeft: '1rem',
              display: 'inline',
              margin: '1rem 0 1rem 0'
          }}/>
      </div>
    );
}

const mapPropsToState = state =>({
    gameroom: state.match.gameroom,
    location: state.match.location
});
export default connect(mapPropsToState)(Game);
export {Game as GamePure};


// WEBPACK FOOTER //
// ./src/comps/game.js